export type ThemeId = "violet" | "dark";

export interface ThemeOption {
  id: ThemeId;
  cssClass: string;
  swatch: string;
  labelKey: string;
}

export const THEME_OPTIONS: readonly ThemeOption[] = [
  { id: "violet", cssClass: "theme-violet", swatch: "#7446b8", labelKey: "settings.themes.violet" },
  { id: "dark", cssClass: "theme-dark", swatch: "#151924", labelKey: "settings.themes.dark" },
] as const;

export const DEFAULT_THEME_ID: ThemeId = "violet";

export function isThemeId(value: unknown): value is ThemeId {
  return value === "violet" || value === "dark";
}

export function getThemeOption(id: ThemeId): ThemeOption {
  return (
    THEME_OPTIONS.find((option) => option.id === id) ??
    THEME_OPTIONS.find((option) => option.id === DEFAULT_THEME_ID)!
  );
}
